import { render, staticRenderFns } from "./TheSalonList.vue?vue&type=template&id=342c62cf"
import script from "./TheSalonList.vue?vue&type=script&lang=js"
export * from "./TheSalonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports